import React, {useContext, useState} from "react";
import {AspectRatio, Box, Button, Container, FormControl, FormLabel, Input, Sheet, Stack, Typography} from "@mui/joy";
import firebase from "firebase/compat/app";
import "firebase/compat/auth"
import {Email, Key, Visibility, VisibilityOff} from "@mui/icons-material";
import {useLocation} from "react-router-dom";
import {FeedbackContext} from "../utils/FeedbackContext";
import Logo from "../assets/app_logo.png"
import {useTranslation} from "react-i18next";
import {Navbar} from "./Navbar";


export function Login() {

    const { i18n, t } = useTranslation();
    const {loading, setError} = useContext(FeedbackContext)
    enum TABS {
        LOGIN,
        RESET_PSW,
        CONFIRM_RESET_PSW,
    }
    const location = useLocation()

    const [tab, setTab] = useState<TABS>(TABS.LOGIN)
    const [email, setEmail] = useState("")
    const [password, setPassword] = useState("")
    const [pswvisible, setPswvisible] = useState(false)

    switch (tab) {
        case TABS.LOGIN :
            return (
                <Box sx={{height: '100vh'}}>
                    <Navbar />
                    <Container maxWidth="sm" sx={{height: '100%', display:"flex", alignItems:"center"}}>
                        <Stack direction="column" spacing={2} sx={{width:"100%"}}>
                            <Box sx={{ display: 'flex', gap: 1, flexDirection:"column", justifyContent:"center", alignItems: 'center' }}>
                                <AspectRatio ratio={1} sx={{width:85, borderRadius:20}}>
                                    <Sheet variant="soft" sx={{backgroundColor:"white"}}>
                                        <img src={Logo} alt="Logo" width={100} height={100}/>
                                    </Sheet>
                                </AspectRatio>
                                <Typography level="h2">CineFX</Typography>
                            </Box>
                            <Box sx={{display:"flex", justifyContent:"center"}}>

                            </Box>
                            <FormControl>
                                <FormLabel>
                                    {t("email")}
                                </FormLabel>
                                <Input type="email"
                                       placeholder={t("emailplaceholder")}
                                       value={email}
                                       onChange={(e) => setEmail(e.target.value)}
                                       startDecorator={<Email />}
                                       onKeyDown={(event) => {
                                           if (event.key === 'Enter') {
                                               SignIn(email, password, location.state).then(() => {})
                                           }
                                       }}
                                       autoFocus
                                />
                            </FormControl>
                            <FormControl>
                                <FormLabel>
                                    {t("password")}
                                </FormLabel>
                                <Input type={pswvisible ? "text" : "password"}
                                       placeholder="********"
                                       value={password}
                                       onChange={(e) => setPassword(e.target.value)}
                                       startDecorator={<Key />}
                                       endDecorator={
                                           pswvisible ?
                                               <VisibilityOff onClick={() => setPswvisible(!pswvisible)} />
                                               :
                                               <Visibility onClick={() => setPswvisible(!pswvisible)} />
                                       }
                                       onKeyDown={(event) => {
                                           if (event.key === 'Enter') {
                                               SignIn(email, password, location.state).then(() => {})
                                           }
                                       }}
                                />
                            </FormControl>
                            <Button variant="solid"
                                    color="primary"
                                    onClick={() => SignIn(email, password, location.state)}
                                    disabled={!email || !password || loading}
                                    onKeyDown={(event) => {
                                        if (event.key === 'Enter') {
                                            SignIn(email, password, location.state).then(() => {})
                                        }
                                    }}
                            >
                                {t("login")}
                            </Button>

                            <Typography level="body-sm" textAlign="center" className="link" onClick={() => setTab(TABS.RESET_PSW)}>
                                {t("passwordforgot")}
                            </Typography>
                        </Stack>
                    </Container>
                </Box>
            )
        case TABS.RESET_PSW :
            return (
                <Box sx={{height: '100vh'}}>
                    <Container maxWidth="sm" sx={{height: '100%', display:"flex", alignItems:"center"}}>
                        <Stack direction="column" spacing={2} sx={{width:"100%"}}>

                            <Box sx={{ display: 'flex', gap: 1, flexDirection:"column", justifyContent:"center", alignItems: 'center' }}>
                                <AspectRatio ratio={1} sx={{width:85, borderRadius:20}}>
                                    <Sheet variant="soft" sx={{backgroundColor:"white"}}>
                                        <img src={Logo} alt="Logo" width={100} height={100}/>
                                    </Sheet>
                                </AspectRatio>
                                <Typography level="h2">CineFX</Typography>
                            </Box>
                            <Box sx={{display:"flex", justifyContent:"center"}}>

                            </Box>

                            <Typography level="body-sm" className="link" onClick={() => setTab(TABS.LOGIN)}>
                                &larr; {t("back")}
                            </Typography>

                            <FormControl>
                                <FormLabel>
                                    Email
                                </FormLabel>
                                <Input type="email"
                                       placeholder={t("emailplaceholder")}
                                       value={email}
                                       onChange={(e) => setEmail(e.target.value)}
                                       startDecorator={<Email />}
                                />
                            </FormControl>

                            <Button variant="solid"
                                    color="primary"
                                    onClick={() => ResetPsw(email)}
                                    disabled={!email || loading}
                            >
                                {t("resetpsw")}
                            </Button>

                        </Stack>
                    </Container>
                </Box>
            )
        case TABS.CONFIRM_RESET_PSW :
            return (
                <Box sx={{height: '100vh'}}>
                    <Container maxWidth="sm" sx={{height: '100%', display:"flex", alignItems:"center"}}>
                        <Stack direction="column" spacing={2} sx={{width:"100%"}}>

                            <Typography level="body-md" textAlign="center" >
                                {t("emailsent")}
                            </Typography>

                            <Button variant="solid"
                                    color="primary"
                                    onClick={() => setTab(TABS.LOGIN)}
                            >
                                {t("backtologin")}
                            </Button>

                        </Stack>
                    </Container>
                </Box>
            )
    }


    async function SignIn(email: string, password: string, url: { from: string } | null) {
        try {
            await firebase.auth().signInWithEmailAndPassword(email, password)
            if(url) window.location.replace(url.from)
        } catch (e: unknown) {
            setError(e)
        }
    }
    async function ResetPsw(email: string) {
        try {
            await firebase.auth().sendPasswordResetEmail(email).then(() => {
                alert(t("emailsent"))
                setTab(TABS.LOGIN)
            })
        } catch (e: unknown) {
            setError(e)
        }
    }
}